<template>
    <el-col class="mb10" :xs="24">
        <div class="w100 cl-f" v-if="typeData.data.length > 0">
            <div class="fl cu-p radio-btn" :class="value == val.value ? 'active' : ''" v-for="(val, key) in typeData.data" :key="key" @click="value = val.value, clickRadio()">{{ val.label }}</div>
        </div>
    </el-col>
</template>

<script>
export default {
    name: 'ServerRadioComp',
    props: ['type-data'],
    components: {},
    data() {
        return {
            value: this.typeData.value || this.typeData.value == '' ? this.typeData.value : null
        };
    },
    created() {},
    computed: {},
    mounted() {},
    methods: {
        clickRadio() {
            this.$emit('fetch-data');
        }
    }
};
</script>

<style scoped>
.radio-btn {
    margin: 0 10px 5px 0;
    padding: 5px 10px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.radio-btn:hover {
    background: rgba(70, 95, 192, 0.1);
}

.radio-btn.active {
    padding: 6px 11px;
    border: none;
    background: rgb(70, 95, 192);
    color: #fff;
}
</style>

